import { render, staticRenderFns } from "./CabinetDetails.vue?vue&type=template&id=597fc3f2&scoped=true"
import script from "./CabinetDetails.vue?vue&type=script&lang=js"
export * from "./CabinetDetails.vue?vue&type=script&lang=js"
import style0 from "./CabinetDetails.vue?vue&type=style&index=0&id=597fc3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597fc3f2",
  null
  
)

export default component.exports